
<div  [ngStyle]="{'background-color':color?.PrimaryColor}" style="background-color:rgb(234,250,254);overflow-y: scroll ;max-height:100% ;" >
    <!--(scroll)="onScroll($event)"  -->
  <span #tops></span>
  
  <app-bus   style="font-size: small; "   (myOutput)="searchBus()" ></app-bus>
  
  <div  class=" col-lg-12  " style="max-width: 100%; margin-top: -80px;position: sticky;  width:100%;"  > 
  <div *ngIf="!showPending"  class=" col-md-12 " style="margin-top: 20px;padding:20px ;overflow:auto;">
   
  <!--###################################   table ##################################################
       ###################################   table ################################################## 
        ###################################   table ##################################################-->
  
 
        <!-- <table mat-table [dataSource]="insuranceDataList" class="mat-elevation-z8 ">

            <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
              <th mat-header-cell *matHeaderCellDef >
                <ng-container [ngSwitch]="columnHeaderMap[col] || col" >
                    <span *ngSwitchCase="'name'">Coverage Coverages Limit</span>
                    <span *ngSwitchCase="'coverageType'">Indemnity / Fixed Benefits</span>
                    <span *ngSwitchCase="'deductible'">Deductible</span>
                    <span *ngSwitchCase="'siOption'">SI Option</span>
                    <span *ngSwitchCase="'refNo'">Ref. No</span>

                    	
                    <span *ngSwitchDefault>{{ columnHeaderMap[col] || col }}</span>
                  </ng-container>
                
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="col.startsWith('planType'); else normalCell">
                <span [innerHTML]="getSumInsuredByPlanType(element, col)">  {{ getSumInsuredByPlanType(element, col) }}</span>
                </ng-container>
                <ng-template #normalCell>
                  {{ element[col] }}
                </ng-template>
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          
          </table> -->
          <div class="table-wrapper zoomI ">
          <!-- bus-search.component.html -->
<div class="containerssss">
    <!-- Sidebar Filters -->
    <aside class="sidebar">
      <h2>Filters</h2>
  
      <div class="filter-block">
        <label>AC</label>
        <div>❄️ AC</div>
      </div>
  
      <div class="filter-block">
        <label>Seat type</label>
        <input type="checkbox" checked /> Sleeper
      </div>
  
      <div class="filter-block">
        <label>Single Seater/Sleeper</label>
        <input type="checkbox" /> Single Seats
      </div>
  
      <div class="filter-block">
        <label>Pick up point - Delhi</label>
        <input type="text" placeholder="Search" />
        <div class="checkbox-list">
          <div><input type="checkbox" /> Morigate</div>
          <div><input type="checkbox" /> Karol Bagh</div>
          <div><input type="checkbox" /> Dhaula Kuan</div>
          <div><input type="checkbox" /> Mahipalpur</div>
        </div>
      </div>
  
      <div class="filter-block">
        <label>Pick up time - Delhi</label>
        <div>
          <div><input type="radio" name="pickupTime" /> 12 PM - 6 PM</div>
          <div><input type="radio" name="pickupTime" /> 6 PM - 12 AM</div>
        </div>
      </div>
  
      <div class="filter-block">
        <label>Operators</label>
        <input type="text" placeholder="Search" />
        <div>
          <div><input type="checkbox" /> Hans Travels (I) Private Limited</div>
          <div><input type="checkbox" /> Ravina Travels (Regd)</div>
        </div>
      </div>
    </aside>
  
    <!-- Main Panel -->
    <main class="main-content">
      <!-- <h1>Delhi to Mumbai (Bombay), Maharashtra Bus</h1> -->
  
      <!-- <div class="top-bar">
        <div class="dates">
          <button>18 Jun, Wed</button>
          <button class="active">19 Jun, Thu</button>
          <button>20 Jun, Fri</button>
        </div>
        <select>
          <option>Relevance</option>
          <option>Rating</option>
          <option>Price</option>
          <option>Fastest</option>
          <option>Departure</option>
          <option>Arrival</option>
        </select>
      </div> -->
  
      <div *ngFor="let bus of buss" class="bus-card">
        <!-- Header -->
        <div class="bus-card-header">
          <div class="bus-info">
            <h2>{{ bus.operatorName }}</h2>
            <p>{{ bus.busType }}</p>
            <div class="rating">
              <span class="rating-box">⭐ 4.2</span>
              <span class="live-tracking">• Live Tracking</span>
            </div>
          </div>
      
          <div class="timing-info">
            <div>
              <strong>{{ bus.departureTime | date: 'HH:mm' }}</strong>
              <span>{{ bus.departureTime | date: 'dd MMM' }}</span>
            </div>
            <div class="duration">{{ bus.duration }}</div>
            <div>
              <strong>{{ bus.arrivalTime | date: 'HH:mm' }}</strong>
              <span>{{ bus.arrivalTime | date: 'dd MMM' }}
                <small *ngIf="getDayDifference(bus.departureTime, bus.arrivalTime)">
                  {{ getDayDifference(bus.departureTime, bus.arrivalTime) }}
                </small>
                 </span>
            </div>
          </div>
      
          <div class="fare-box">
            <div class="fare">₹{{ bus.fare[0]?.totalFare }}</div>
            <div class="availability">{{ bus.availableSeats }} Seats Left | 12 Single Seats</div>
          </div>
        </div>
      
        <!-- Toggle Seats -->
        <div class="bus-card-footer">
          <div class="footer-options">
            <span>Photos</span>
            <span>Amenities ⌄</span>
            <span>Pickup & Drop Points ⌄</span>
            <span>Ratings & Reviews ⌄</span>
            <span>Policies ⌄</span>
          </div>
          <button class="select-btn" (click)="onClickSBuseats(bus)">
            {{ bus.showSeats ? 'HIDE SEATS' : 'SELECT SEATS' }}
          </button>
        </div>
      
        <!-- Seat and Points Layout -->
        <div *ngIf="bus.showSeats" class="seat-layout">


          
          <div class="column" >
            <h4>Select Seats</h4>
            <!-- <div class="seat-grid">
              <ng-container *ngFor="let i of busDetails?.seats">
                <div class="seat">
                  <span style="text-transform: uppercase;">Seat No {{i?.name}}</span>
                  <div>₹{{ i?.fare }}</div>
                  


                </div>
              </ng-container>
            </div> -->
            <div *ngFor="let row of seatRows | keyvalue : columnSorter" >
              <div class="seat-row">
                <div class="seat" *ngFor="let seat of asArray(row.value)">
                  <span style="text-transform: uppercase;font-size: 9px;">Seat No <span style="color: rgb(0, 123, 255);font-weight: bold;font-size: 12px;">{{ seat.name }}</span></span>
                  <div>₹{{ seat.fare }}</div>
                </div>
              </div>
            </div>
          </div>
          
         
      
          <!-- <div *ngIf="false" class="column">
            <h4>Know your seats</h4>
            <h5>UPPER BERTH (18)</h5>
            <div class="seat-grid">
              <ng-container *ngFor="let i of [].constructor(18)">
                <div class="seat">
                  <img src="https://img.icons8.com/ios-filled/50/seat.png" alt="seat" />
                  <div>₹{{ busDetails.fare[0]?.totalFare }}</div>
                </div>
              </ng-container>
            </div>
          </div> -->
      
          <div class="column">
            <h4>Select Pickup & Drop Points</h4>
            <!-- Boarding Points -->
            <div class="points">
              <h5>BOARDING POINTS</h5>
              <div *ngFor="let bp of busDetails.boardingPoint" class="point-box" (click)="selectedBoarding = bp.bpId" [class.selected]="selectedBoarding === bp.bpId">
                <strong>{{ bp.time | date: 'HH:mm, dd MMM' }}</strong>
                <div>{{ bp.location }}</div>
                <small>{{ bp.address }}</small><br />
                <small>{{ bp.contactNumber }}</small>
              </div>
            </div>
            <!-- Dropping Point -->
            <div class="points">
              <h5>DROP POINTS</h5>
              <div *ngFor="let bp of busDetails.droppingPoint" class="point-box" (click)="selectedDrop = bp.dpId" [class.selected]="selectedDrop === bp.dpId">

              <!-- <div class="point-box" (click)="selectedDrop = bus.droppingPoint.dpId" [class.selected]="selectedDrop === bus.droppingPoint.dpId"> -->
                <strong>{{ bp.time | date: 'HH:mm dd MMM' }}</strong>
                <div>{{ bp.location }}</div>
                <small>{{ bp.address }}</small>
              </div>
            </div>
          </div>
        </div>
      
        <!-- Footer: Selected Info -->
        <div *ngIf="bus.showSeats" class="footer-bar">
          <div>
            <b>Selected Seats:</b>
            <span *ngIf="!selectedSeats?.length">No Seats selected yet</span>
            <span *ngFor="let seat of selectedSeats" class="badge">{{ seat }}</span>
          </div>
          <button class="continue-btn" [disabled]="!selectedSeats?.length">CONTINUE</button>
        </div>
      </div>
      
      
      <!-- <div *ngFor="let bus of buses" class="bus-card">
        <div class="bus-header">
          <div>
            <h2>{{ bus.name }}</h2>
            <p>{{ bus.type }}</p>
          </div>
          <div class="time-info">
            <div><strong>{{ bus.departureTime }}</strong> {{ bus.departureDate }}</div>
            <div class="duration">{{ bus.duration }}</div>
            <div><strong>{{ bus.arrivalTime }}</strong> {{ bus.arrivalDate }}</div>
          </div>
        </div>
        <div class="bus-meta">
          <div>🌟 {{ bus.rating }} ({{ bus.reviews }} Reviews) • Live Tracking</div>
          <div>₹{{ bus.price }} • {{ bus.seatsLeft }} Seats Left • {{ bus.singleSeats }} Single Seats</div>
        </div>
        <button *ngIf="bus.showSeats===false" class="select-button" (click)="bus.showSeats=true;onClickSelect(bus.seatConfig,bus.seats.decks)">SELECT SEATS</button>
        <button *ngIf="bus.showSeats===true" class="select-button" (click)="bus.showSeats=false">HIDE SEATS</button>


       

        <div *ngIf="bus.showSeats===true" class="bus-container">
            <div class="seats-section">
              <div class="deck-title">Select Seats</div>
              <div class="berth-title">LOWER BERTH</div>
              <div class="seats-grid">
                
                <ng-container *ngFor="let seat of lowerDeckSeats(bus.seats)">
                  <div
                    class="seat"
                    [ngClass]="{
                      'unavailable': !seat.available,
                      'selected': selectedSeats.includes(seat.id)
                    }"
                    (click)="selectSeats(seat,bus.seats)"
                  >
                    <img [src]="getSeatImage(seat,bus.seats)" alt="seat" />
                    <div class="fare">₹2800</div>
                  </div>
                </ng-container>
              </div>
          
              <div class="berth-title">UPPER BERTH</div>
              <div class="seats-grid">
                <ng-container *ngFor="let seat of upperDeckSeats(bus.seats)">
                  <div
                    class="seat"
                    [ngClass]="{
                      'unavailable': !seat.available,
                      'selected': selectedSeats.includes(seat.id)
                    }"
                    (click)="selectSeats(seat,bus.seats)"
                  >
                    <img [src]="getSeatImage(seat,bus.seats)" alt="seat" />
                    <div class="fare">₹2800</div>
                  </div>
                </ng-container>
              </div>
            </div>
          <div class="seats-section">

              <div class="col-lg-12 seat-container" >
                <div  *ngFor="let seatrow of seatmap " >
                    <div class="col-12 pricing-label" *ngIf="seatChartConfig?.showRowWisePricing && seatrow.seatPricingInformation != ''">{{seatrow.seatPricingInformation}}</div>
                    <div class="seatrow container">
                        <div *ngIf="seatChartConfig?.showRowsLabel">
                            <div class="row-label" >  {{seatrow.seatRowLabel}} </div>
                        </div>
                        <div *ngFor="let seatobj of seatrow.seats">
                            <div class="seat-item seat-space" style="color:white ; background-color:white" *ngIf="seatobj.seatLabel == ''">  &nbsp; </div>
                            <div   pTooltip="Seat : {{seatobj.seatLabel}} | Price : {{seatobj.price}}Rs" tooltipPosition="top"
                            [ngClass]="{ 'seat-item' : true , 'seat-available' : seatobj.status == 'available' ,'seat-booked' : seatobj.status == 'booked' ,'seat-unavailable' : seatobj.status == 'unavailable' }" 
                             (click)="selectSeat(seatobj)" *ngIf="(seatobj.status == 'available' || seatobj.status == 'booked' )&& seatobj.seatLabel != ''">{{seatobj.seatNo}}
                             <div class="fareSeat">₹2800</div>
                            </div>
                             
                            <div pTooltip="Seat not available" tooltipPosition="top"
                            [ngClass]="{ 'seat-item' : true , 'seat-unavailable' : true }" 
                            *ngIf="seatobj.status == 'unavailable' && seatobj.seatLabel != ''">{{seatobj.seatNo}}
                            <div class="fareSeat">₹2800</div></div>
                        </div>
                    </div>
                </div>
              </div>
             
          </div>
            <div class="points-section">
              <div class="title">Select Pickup & Drop Points</div>
          
              <div class="points">
                <div class="boarding">
                  <div class="point-title">BOARDING POINTS</div>
                  <div class="point-content">
                    <strong>19:30, 12 JUL</strong>
                    <div>Morigate</div>
                    <small>54, Gokhle Market, Behind Tees Hazari Court, Delhi</small>
                    <small>9424388888,011-40114221</small>
                  </div>
                </div>
          
                <div class="drop">
                  <div class="point-title">DROP POINTS</div>
                  <div *ngFor="let drop of bus.dropPoints" class="drop-point">
                    <strong>{{ drop.time }}</strong>
                    <div>{{ drop.name }}</div>
                    <small>{{ drop.detail }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div *ngIf="bus.showSeats===true"  class="footer">
           
              <div>Total Seats:
                <span *ngIf="cart?.selectedSeats?.length === 0">0</span>
                <span *ngIf="cart?.selectedSeats?.length != 0">{{cart?.selectedSeats?.length}}</span>
            <div>Selected Seats:
                 <span *ngIf="cart?.selectedSeats?.length === 0">No Seats selected yet</span>
                 <span *ngIf="cart?.selectedSeats?.length != 0"> 
                    <span *ngFor="let seatLabel of cart.selectedSeats" class="badge badge-primary">
                        {{seatLabel}}
                 </span></span></div>
                 <div>Total Amount :
                    <span *ngIf="cart?.selectedSeats?.length === 0">0 Rs</span>
                    <span *ngIf="cart?.selectedSeats?.length != 0"> 
                        {{cart.totalamount}} Rs
                       </span></div>
                    </div>
            <button class="continue" [disabled]="selectedSeats.length === 0">CONTINUE</button>
          </div>
      </div> -->
    </main>
  </div>
  





  
          </div>
          
          
          
  </div>
  <!--###################################  pendingFlight.gif ##################################################
       ################################### pendingFlight.gif  ################################################## 
        ################################### pendingFlight.gif ##################################################-->
        <div *ngIf="!showPending&&blankList" class=" no-result-container " style="padding: 1.3rem;text-align: center;background-color: antiquewhite;">
          <div class="icon">
            <!-- Use an SVG or FontAwesome icon for the magnifying glass -->
            <!-- <img src="assets/images/" alt="No Result Icon"> -->
          </div>
          <h2>No Result Found</h2>
          <p>Sorry, there are no matching results</p>
        </div>
        <div *ngIf="showPending" >
    <div class="gif-container">
      <img src="../../../../assets/images/menuImages/bus.png" >
  </div>
  </div>
  
  
 
  
  
   
    